// Recently-viewed product tracking — pure localStorage, no backend.
// Stores up to RECENT_LIMIT product ids in MRU order; the latest tracked
// product is at index 0. Used by the home, PDP, and cart rails.

const STORAGE_KEY = 'se_recently_viewed_v1';
const RECENT_LIMIT = 12;

function readIds() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return [];
    return arr.filter(x => Number.isInteger(x));
  } catch {
    return [];
  }
}

function writeIds(ids) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids.slice(0, RECENT_LIMIT)));
  } catch {}
}

export function trackProductView(id) {
  const pid = Number(id);
  if (!Number.isInteger(pid)) return;
  const ids = readIds().filter(x => x !== pid);
  ids.unshift(pid);
  writeIds(ids);
}

export function getRecentProductIds({ excludeId = null, limit = RECENT_LIMIT } = {}) {
  const ids = readIds();
  const filtered = excludeId == null ? ids : ids.filter(x => x !== Number(excludeId));
  return filtered.slice(0, limit);
}

export function clearRecentlyViewed() {
  try { localStorage.removeItem(STORAGE_KEY); } catch {}
}
